
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.82 7.5h3.36v10h-3.36v-10zm-3.32 0c.443 0 .833.17 1.172.508.338.338.508.729.508 1.172v8.32c0 .443-.17.833-.508 1.172L8.203 24.18l-.898-.899a1.169 1.169 0 01-.352-.86v-.273l.82-3.828H2.5c-.443 0-.833-.156-1.172-.468-.338-.339-.508-.73-.508-1.172V15c0-.208.04-.417.118-.625l2.539-5.86C3.737 7.84 4.245 7.5 5 7.5h7.5z"}})])
          )
        }
      }
    